import API from "../../api/Routes";
import ACTION from "../../actions";
import { API_URL } from "../../config";
import ApiServices from "../../services/Api.services";
import { showErrorToast } from "../../utils/Functions";

/*********************************** 
@Purpose : Used to Signing Document  Listing
@Parameter : payload
@Author : INIC
**********************************/
export const signingListing = (payload) => async (dispatch) => {
  try {
    await ApiServices.postApi(API_URL + API.SIGNING_LISTING, payload).then(
      (response) => {
        dispatch({
          type: ACTION.SIGNING_LISTING,
          payload: response.data.data,
        });
      }
    );
  } catch (error) {
    showErrorToast(error);
  }
};

/*********************************** 
@Purpose : Used to Signing Document  Listing
@Parameter : payload
@Author : INIC
**********************************/
export const addComment = (payload) => async (dispatch) => {
  try {
    await ApiServices.postApi(API_URL + API.ADD_COMMENT, payload).then(
      (response) => {
        dispatch({
          type: ACTION.ADD_COMMENT,
          payload: response.data,
        });
      }
    );
  } catch (error) {
    showErrorToast(error);
  }
};

/******************* 
@Purpose : Used to get the comment 
@Parameter : payload
@Author : INIC
******************/
export const commentListing = (payload) => async (dispatch) => {
  try {
    await ApiServices.getApi(
      API_URL +
        API.COMMENT_LISTING +
        `?candidateId=` +
        payload.candidateId +
        `&docId=` +
        payload.docId,
      payload
    ).then((response) => {
      dispatch({
        type: ACTION.COMMENT_LISTING,
        payload: response,
      });
    });
  } catch (error) {
    showErrorToast(error);
  }
};
